import { safeDefine } from "../../registration/safe-define.js";
import { SeekButtonElement } from "../../ui/seek-button/element.js";
//#region src/define/ui/seek-button.ts
safeDefine(SeekButtonElement);
//#endregion

//# sourceMappingURL=seek-button.js.map